import * as React from 'react';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const PerspektyvnyiPlanAtestatsiiPedahohichnykhPratsivnykiv_2022_2026rPage = () => {
  return (
    <Layout>
      <article>
        <h2>
          Перспективний план проходження атестації педагогічних працівників <br />
          КЗ «ЗДО «Лісова казка» ВМР» на 2022-2026 роки
        </h2>

        <div className="top-spacing-big scrollable-table">
          <table>
            <thead>
              <tr>
                <th className={'center-text bold-text italic-text'}>№ з/р</th>
                <th className={'center-text bold-text italic-text'}>Прізвище, ім’я, по-батькові</th>
                <th className={'center-text bold-text italic-text'}>Посада</th>
                <th className={'center-text bold-text italic-text'}>Освіта</th>
                <th className={'center-text bold-text italic-text'}>Фах за освітою</th>
                <th className={'center-text bold-text italic-text'} colSpan={2}>
                  Пед.стаж станом на 01.09.2023р
                </th>
                <th className={'center-text bold-text italic-text'}>Рік призначення на посаду</th>
                <th className={'center-text bold-text italic-text'}>Дата попередньої атестації</th>
                <th className={'center-text bold-text italic-text'} colSpan={5}>
                  Дата чергової атестації
                </th>
                <th className={'center-text bold-text italic-text'}>Примітки</th>
              </tr>
              <tr>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}>Загальний</th>
                <th className={'center-text bold-text italic-text'}>На даній посаді</th>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}></th>
                <th className={'center-text bold-text italic-text'}>2022</th>
                <th className={'center-text bold-text italic-text'}>2023</th>
                <th className={'center-text bold-text italic-text'}>2024</th>
                <th className={'center-text bold-text italic-text'}>2025</th>
                <th className={'center-text bold-text italic-text'}>2026</th>
                <th className={'center-text bold-text italic-text'}></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Ваколюк Вікторія Вікторівна</td>
                <td>Директор</td>
                <td>Спец.Вища</td>
                <td>
                  2012р. Вчитель музики, музичний керівник. <br />
                  2018р.Початкова освіта <br />
                  2019р. Вчитель трудового навчання та креслення
                </td>
                <td>12р.3м.</td>
                <td>1р.11м.4д.</td>
                <td>2021р.</td>
                <td>07.04.2023р.</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>2</td>
                <td>ОвчарІнна Олександрівна</td>
                <td>Вихователь</td>
                <td>
                  Спец.Вища <br />
                  2021
                </td>
                <td>
                  2011р. Документознавство.
                  <br />
                  2021р.Початкова освіта. Вихователь дітей раннього віку
                </td>
                <td>3р.10м</td>
                <td>3р.10м.</td>
                <td>2019р.</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>+</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>3</td>
                <td>Паламарчук ВіраГригорівна</td>
                <td>Вихователь</td>
                <td>
                  Спец.Вища <br />
                  2018
                </td>
                <td>
                  2014р. Дошкільна освіта
                  <br />
                  2018р. Спеціаліст з психології
                </td>
                <td>4р.4м</td>
                <td>4р.1м.17 д.</td>
                <td>2019р.</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>+</td>
                <td></td>
                <td>Д.В.</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Приймачук Оксана Миколаївна</td>
                <td>Вихователь</td>
                <td>Спец.Вища</td>
                <td>2008р. Вчитель трудового навчання</td>
                <td>6р.11м.</td>
                <td>1р.10м.</td>
                <td>2021р.</td>
                <td>2016р.</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>+</td>
                <td></td>
              </tr>
              <tr>
                <td>5</td>
                <td>Стецюра Вікторія Степанівна</td>
                <td>Вихователь</td>
                <td>Спец.Вища</td>
                <td>
                  2014р. Дошкільна освіта
                  <br />
                  2016р. Викладач дошкільної педагогіки та психології
                </td>
                <td>9р.5м.4д.</td>
                <td>3р.2м.</td>
                <td>2020р.</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>+</td>
                <td></td>
                <td>Д.В.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>
    </Layout>
  );
};

export default PerspektyvnyiPlanAtestatsiiPedahohichnykhPratsivnykiv_2022_2026rPage;

export const Head = () => <SEO title="Перспективний план атестації педагогічних працівників 2022-2026р" />;
